import { type AreaVisibilityPreference } from '@terros/common'
import { type SelectItem } from '../types'

export const AREA_VISIBILITY_OPTIONS: SelectItem<AreaVisibilityPreference>[] = [
  {
    label: 'Show only direct assigned areas',
    value: 'Self',
  },
  {
    label: 'Show all areas in the company',
    value: 'All',
  },
  {
    label: 'Show areas of team',
    value: 'DirectTeam',
  },
]

export const UNIT_SYSTEM_SELECT_OPTIONS: SelectItem<'imperial' | 'metric'>[] = [
  {
    label: 'Imperial',
    value: 'imperial',
  },
  {
    label: 'Metric',
    value: 'metric',
  },
]
